import React from 'react'
import { useNotification } from '@/hooks/useNotification'
import NotificationToast from './NotificationToast'

const NotificationContainer: React.FC = () => {
  const { notifications } = useNotification()

  return (
    <div className="notification-container">
      {notifications.map(notification => (
        <NotificationToast
          key={notification.id}
          notification={notification}
        />
      ))}
    </div>
  )
}

export default NotificationContainer